var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogOut = function SvgLogOut(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5303 11.4697L11.0303 7.96967C10.7374 7.67678 10.2626 7.67678 9.96967 7.96967C9.67678 8.26256 9.67678 8.73744 9.96967 9.03033L12.1893 11.25L2.5 11.25C2.08579 11.25 1.75 11.5858 1.75 12C1.75 12.4142 2.08579 12.75 2.5 12.75L12.1893 12.75L9.96967 14.9697C9.67678 15.2626 9.67678 15.7374 9.96967 16.0303C10.2626 16.3232 10.7374 16.3232 11.0303 16.0303L14.5303 12.5303C14.8232 12.2374 14.8232 11.7626 14.5303 11.4697Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 2.25C21.2688 2.25 22.5 3.48122 22.5 5V19C22.5 20.5188 21.2688 21.75 19.75 21.75H10.5C10.0858 21.75 9.75 21.4142 9.75 21C9.75 20.5858 10.0858 20.25 10.5 20.25H19.75C20.4404 20.25 21 19.6904 21 19V5C21 4.30964 20.4404 3.75 19.75 3.75L10.5 3.75C10.0858 3.75 9.75 3.41421 9.75 3C9.75 2.58579 10.0858 2.25 10.5 2.25L19.75 2.25Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogOut);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "log-out.37a28cbf2e1718345b4b687ae6e82edc.svg";